/*
 * @LastEditors: zhanglinju
 */

// import pageMana from './pageMana/router'; // 站点管理
// import templateMana from './templateMana/router'; // 模板管理
// import authority from './authority/router'; // 权限管理
export const index = () => import(/* webpackChunkName: "textproject" */ './index');
export const content = () => import(/* webpackChunkName: "textproject" */ './content');
export const make = () => import(/* webpackChunkName: "textproject" */ './make');
export const column = () => import(/* webpackChunkName: "textproject" */ './column');

export const carousel = () => import('./carousel');
export const page = () => import('./page');
export const webpage = () => import('./webPage.vue');
export default [
    {
        path: '/front',
        name: 'front',
        component: index,
        meta: {
            // access: {
            //     customCode: ['04299001'],
            // },
            client: 'front',
        },
        children: [
            { path: 'contentManage', name: 'contentManage', component: content },
            { path: 'make', name: 'make', component: make },
            { path: 'column', name: 'column', component: column },
            { path: 'carousel', name: 'carousel', component: carousel },
            { path: 'page', name: 'page', component: page },
            { path: 'webpage', name: 'webpage', component: webpage },
        ],
    },
];
